import {FC, KeyboardEvent, useState} from 'react'
import {GetSubClientsParam} from '../../../../../services/cellcast.v2.types'
import {KTSVG} from '../../../../../_metronic/helpers'
import Select from 'react-select'
import {IndustryOptions} from '../../../AdminPages/AllCellCastUser/Constant/CellCastConstant'
import DatePicker from 'react-datepicker'
import useResponsive from '../../../../hooks/useResponsive'

export type ListFilterProps = {
  params: GetSubClientsParam
  setParams: (p: GetSubClientsParam) => void
  doFetch: () => void
}

const ListFilter: FC<ListFilterProps> = ({params, setParams, doFetch}) => {
  const [filterOpen, setFilterOpen] = useState<boolean>(false)
  const {isMobile} = useResponsive()
  const [filterStatusOptions] = useState([
    {value: '', label: 'Select Status'},
    {value: 'active', label: 'Active'},
    {value: 'inactive', label: 'Inactive'},
    {value: 'suspended', label: 'Suspended'},
  ])

  const handleSearchEnter = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      doFetch()
    }
  }

  return (
    <div className={`d-flex mt-5 align-items-start position-relative my-1 flex-column flex-sm-row ${isMobile ? '' : ''}`}>
      <div className={`relative ${isMobile ? 'w-100' : ''}`}>
        <KTSVG
          path='/media/icons/duotune/general/gen021.svg'
          className='svg-icon-1 position-absolute ms-6 mt-3'
        />
        <input
          type='text'
          value={params.search ? params.search : ''}
          data-kt-user-table-filter='search'
          className={`form-control form-control-solid ps-14 ${isMobile ? 'w-100' : 'w-250px'}`}
          placeholder='input and press enter'
          onChange={(e: any) => setParams({...params, search: e.target.value, page: 1})}
          onKeyDown={handleSearchEnter}
        />
      </div>
      <div
        onMouseEnter={() => setFilterOpen(true)}
        onMouseLeave={() => setFilterOpen(false)}
        className='filter_parent'
      >
        <button
          className={`btn btn-light-primary ms-3 me-3 filter_btn ${
            filterOpen && 'show menu-dropdown'
          } `}
          data-kt-menu-placement='bottom-end'
        >
          <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
          Filter
        </button>

        <div
          className={`menu menu-sub menu-sub-dropdown w-250px w-md-300px ${
            filterOpen && 'show filtermenu'
          }`}
        >
          <div className='px-7 py-5'>
            <div className='mb-10'>
              <label className='form-label fw-bold'>Status:</label>

              <div>
                <Select
                  name='status'
                  value={
                    filterStatusOptions.find((el) => el.value === params.status) ||
                    filterStatusOptions[0]
                  }
                  className='form-select form-select-solid fw-bolder'
                  onChange={(e: any) => setParams({...params, status: e.value, page: 1})}
                  options={filterStatusOptions}
                />
              </div>
            </div>

            <div className='mb-10'>
              <label className='form-label fw-bold'>Industry:</label>
              <Select
                value={
                  IndustryOptions.find((el) => el.value === params.industry) || {
                    label: 'Select industry',
                    value: '',
                  }
                }
                className='form-select form-select-solid fw-bolder'
                name='industry'
                onChange={(e: any) => setParams({...params, industry: e.value, page: 1})}
                options={IndustryOptions}
              />
            </div>

            <div className='d-flex justify-content-end'>
              <button
                type='submit'
                className='btn btn-sm btn-white btn-active-light-primary me-2'
                onClick={() => {
                  setParams({...params, page: 1, industry: '', status: ''})
                  setFilterOpen(false)
                  doFetch()
                }}
              >
                Reset
              </button>

              <button
                type='submit'
                className='btn btn-sm btn-primary'
                data-kt-menu-dismiss='true'
                onClick={() => {
                  setParams({...params, page: 1})
                  setFilterOpen(false)
                  doFetch()
                }}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ListFilter
